<div>
  <app-aaos-basic-address *ngFor="let addressDetail of addressDetails; let i = index" [dynamicForm]="dynamicForm"
    [applicationCountries]="applicationCountries" [addressIndex]="i" [addressDetail]="addressDetail"
    (componentChanged)="onComponentChange($event)" [fieldsPrerequisite]="fieldsPrerequisite"></app-aaos-basic-address>
</div>
<button *ngIf="fieldsPrerequisite.multipleAddresses" class="btn btn--solid" (click)="addAddress()">ADD ADDRESS</button>
<app-aaos-spinner [isLoading]="isLoading"></app-aaos-spinner>